import React from "react";
import {
    Navigate,
} from "react-router-dom";

const CustomerListComponent = React.lazy(() => import("../../../components/customer/components/list/page"));
const CustomerAddComponent = React.lazy(() => import("../../../components/customer/components/add/page"));

export const customerRoute = [
    {
        path: 'list',
        element: <CustomerListComponent />
    },
    {
        path: 'add',
        element: <CustomerAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/customers/add" />
    },
    {
        path: 'edit/:id',
        element: <CustomerAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/customers/list" />
    },
];
